export default __webpack_public_path__ + "static/IMAGEM_2_1-99a2648700d49462d06c537c4cc7be55.png";